import { useEffect, useRef } from "react";
import toast from "react-hot-toast";

const useMeetingReminder = (meetings, userId) => {
  const notifiedRef = useRef(new Set());

  console.log("✅ useMeetingReminder hook is loaded");

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const tenMins = 10 * 60 * 1000;

      console.log("⏱ Checking meetings...");

      meetings.forEach((m) => {
        const time = new Date(m.time);
        const diff = time - now;

        const isSoon = diff > 0 && diff <= tenMins;
        const id = m._id;

        if (isSoon && !notifiedRef.current.has(id)) {
          const withUser =
            m.organizer._id === userId
              ? m.participant.username
              : m.organizer.username;

          console.log("🚨 Reminder triggered for:", withUser);

          toast.custom((t) => (
            <div
              className={`bg-white shadow-md rounded px-4 py-3 text-sm flex justify-between items-center w-full max-w-sm transition-all ${t.visible ? "opacity-100" : "opacity-0"
                }`}
            >
              <span>
                ⏰ Meeting with <span className="font-semibold">{withUser}</span> in 10 minutes!
              </span>
              <button
                onClick={() => toast.dismiss(t.id)}
                className="ml-4 text-gray-500 text-xs hover:text-red-500"
              >
                ✖
              </button>
            </div>
          ), {
            duration: Infinity,
          });

          notifiedRef.current.add(id);
        }
      });
    }, 30000); // every 30s

    return () => clearInterval(interval);
  }, [meetings, userId]);
};

export default useMeetingReminder;
